import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { useApiInstance } from './useApiInstance'

interface ArchiveUserContractorParams {
  userContractorId: number;
}

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, ArchiveUserContractorParams>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useArchiveUserContractorRequest = ({
  options
}: RequestParams = {}) => {
  const api = useApiInstance()
  return useMutation(
    ({ userContractorId }: ArchiveUserContractorParams) =>
      api.v1AdminUsersUsersContractorsUserContractorIdArchivePost(userContractorId),
    { ...options }
  )
}

export const useUnarchiveUserContractorRequest = ({
  options
}: RequestParams = {}) => {
  const api = useApiInstance()
  return useMutation(
    ({ userContractorId }: ArchiveUserContractorParams) =>
      api.v1AdminUsersUsersContractorsUserContractorIdUnarchivePost(userContractorId),
    { ...options }
  )
}
